export default __webpack_public_path__ + "static/ScreenCrowWhite-a0d4e6839ac8215530a6498a633e7355.png";